// Audio: music tracks, sound effects, event map (Phase 6).
import { api } from './client';

export const soundsApi = {
  // ---- Public (storefront audio engine) ----
  get(): Promise<{ settings: any; tracks: any[]; events: { event_key: string; file_url: string }[] }> {
    return api('/catalog/sounds');
  },

  // ---- Admin: tracks ----
  adminTracks(): Promise<{ items: any[] }> {
    return api('/admin/sound-tracks', { auth: true });
  },
  createTrack(body: { name: string; fileUrl: string; durationSeconds?: number; sortOrder?: number }): Promise<{ ok: true }> {
    return api('/admin/sound-tracks', { method: 'POST', body, auth: true });
  },
  updateTrack(id: string, body: Partial<{ name: string; isEnabled: boolean; is_enabled: boolean; sortOrder: number; sort_order: number }>): Promise<{ ok: true }> {
    return api(`/admin/sound-tracks/${id}`, { method: 'PUT', body, auth: true });
  },
  removeTrack(id: string): Promise<{ ok: true }> {
    return api(`/admin/sound-tracks/${id}`, { method: 'DELETE', auth: true });
  },

  // ---- Admin: effects ----
  adminEffects(): Promise<{ items: any[] }> {
    return api('/admin/sound-effects', { auth: true });
  },
  createEffect(body: { name: string; fileUrl: string; durationSeconds?: number }): Promise<{ id: string }> {
    return api('/admin/sound-effects', { method: 'POST', body, auth: true });
  },
  updateEffect(id: string, name: string): Promise<{ ok: true }> {
    return api(`/admin/sound-effects/${id}`, { method: 'PUT', body: { name }, auth: true });
  },
  removeEffect(id: string): Promise<{ ok: true }> {
    return api(`/admin/sound-effects/${id}`, { method: 'DELETE', auth: true });
  },

  // ---- Admin: event map ----
  adminEventMap(): Promise<{ items: { event_key: string; sound_effect_id: string | null }[] }> {
    return api('/admin/sound-event-map', { auth: true });
  },
  setEvent(event_key: string, sound_effect_id: string | null): Promise<{ ok: true }> {
    return api('/admin/sound-event-map', { method: 'PUT', body: { event_key, sound_effect_id }, auth: true });
  },
};
